import React from "react";
import { Line } from "react-chartjs-2";

const CycleTimeTrend = () => {

  const data = {
    labels: ["Sprint1","Sprint2","Sprint3","Sprint4"],
    datasets: [
      {
        label: "Cycle Time (Days)",
        data: [3.2,4.8,2.7,3.4],
        borderColor: "#22c55e",
        backgroundColor: "rgba(34,197,94,0.2)"
      }
    ]
  };

  return (
    <div className="bg-gray-800 p-5 rounded-xl">
      <h3 className="text-white mb-4">⏱ Cycle Time Trend</h3>
      <Line data={data}/>
    </div>
  );
};

export default CycleTimeTrend;